import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loading= false;
  submitted= false;
  returnlUrl: string;
  error = '';
  viewModel= {
    btnLoginCasplock: false,
    caspLockEnable: false,
    ListMenuDynamic: [],
  };
  /**
   *
   */
  constructor(private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router) {
      this.authenticationService.logout();
  }
  get f() { return this.loginForm.controls; }
  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
  });
  }
  // tslint:disable-next-line: one-line
  onSubmit(){
    this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }
        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
  .subscribe(data => {
    if (data.Success) {
      if (data.Data.AccessToken) {
        localStorage.clear();
        this.authenticationService.token = data.Data.AccessToken;
        this.authenticationService.userName = data.Data.UserName;
        localStorage.setItem('UserName', data.Data.UserName ? data.Data.UserName : null);
        localStorage.setItem('Token', data.Data.AccessToken ? data.Data.AccessToken : null);
        localStorage.setItem('RoleId', data.Data.RoleId ? data.Data.RoleId : null);
        this.router.navigate(['/']);
      }
    } else {
      this.error = data.Message;
      this.loading = false;
    }
  },
      error => {
          this.loading = false;
      });

}
checkCapSlock(event) {
  const myKeyCode = event.which ? event.which : (event.keyCode ? event.keyCode : (event.charCode ? event.charCode : 0));
  const myShiftKey = event.shiftKey || (event.modifiers && (event.modifiers & 4));
  if (((myKeyCode >= 65 && myKeyCode <= 90) && !myShiftKey) || ((myKeyCode >= 97 && myKeyCode <= 122) && myShiftKey)) {
      this.viewModel.btnLoginCasplock = true;

  } else {
      this.viewModel.btnLoginCasplock = false;
  }
  // if(this.model.password == null){
  //
  // }
}
}
